<template>
  <div class="slick_wrapper" @touchstart="onTouchStart" ref="wrapper" :style="{'height': wrapperHeight+'px'}">
    <div class="slick_monitor" :style="{'margin-left': this.left + 'px',transition}" ref="monitor">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Flick",
  data() {
    return {
      wrapperHeight:0,
      startX: 0,
      left: 0,
      maxX: 0,
      power: 0,
      transition: "",
      last_touch_move_event: {
        timestamp: 0,
        clientX: 0,
        clientY: 0,
        xDirection: 0,
      },
    }
  },
  methods: {
    onTouchMove(e) {
      const old_te = this.last_touch_move_event;
      const new_touch = e.changedTouches[0];

      this.last_touch_move_event = {
        timestamp: e.timeStamp,
        clientX: new_touch.clientX,
        clientY: new_touch.clientY
      }

      this.xDirection = old_te.clientX - new_touch.clientX > 0 ? -1 : 1;

      this.power = Math.abs((old_te.clientX - new_touch.clientX)
          / (this.last_touch_move_event.timestamp - old_te.timestamp));

      this.left = new_touch.clientX - this.startX;
      this.left = Math.min(this.left,0);
      this.left = Math.max(this.left,this.maxX);
    },

    onTouchStart(e) {
      this.startX = e.changedTouches[0].clientX - this.left;

      const wrapper_rect = this.$refs.wrapper.getBoundingClientRect();
      const monitor_rect = this.$refs.monitor.getBoundingClientRect();
      this.maxX = wrapper_rect.width - monitor_rect.width;

      this.transition = "";

      document.addEventListener("touchmove",this.onTouchMove);
      document.addEventListener("touchend",this.onTouchEnd);
    },

    onTouchEnd(e) {
      if(e.timeStamp - this.last_touch_move_event.timestamp < 30){

        this.transition = "all .5s ease-out";
        if(this.power > 1){
          this.left += this.power * 120 * this.xDirection;
        }else{
          this.left += this.power * 80 * this.xDirection;
        }

        if(this.left >= 0 || this.left <= this.maxX){
          this.transition = "all .3s linear";
        }

        this.left = Math.min(this.left,0);
        this.left = Math.max(this.left,this.maxX);
      }

      document.removeEventListener("touchmove",this.onTouchMove);
      document.removeEventListener("touchend",this.onTouchEnd);
    },
    onDocumentResize(){
      this.left = 0;
      this.wrapperHeight = this.$refs.monitor.getBoundingClientRect().height;
    }
  },
  mounted(){
    this.onDocumentResize();
    window.addEventListener("resize",this.onDocumentResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize",this.onDocumentResize);
  }
}
</script>

<style scoped>
  .slick_wrapper {
    overflow: hidden;
    position: relative;
  }
  .slick_monitor {
    display: flex;
    position: absolute;
    min-width: 100%;
    justify-content: space-between;
  }
</style>